import { createContext, useContext, useState } from 'react';

const QRCodeContext = createContext();

export const QRCodeProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openQRCodeModal = () => setIsOpen(true);
  const closeQRCodeModal = () => setIsOpen(false);

  return (
    <QRCodeContext.Provider value={{ isOpen, openQRCodeModal, closeQRCodeModal }}>
      {children}
    </QRCodeContext.Provider>
  );
};

export const useQRCode = () => {
  const context = useContext(QRCodeContext);
  if (!context) {
    throw new Error('useQRCode must be used within a QRCodeProvider');
  }
  return context;
};
